module.exports = __webpack_public_path__ + "bitmo.png?d0715f9dfea4b876b0bdf617d106a9b2";